import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

class AdminAPI {
  constructor() {
    this.token = localStorage.getItem('admin_token');
  }

  setToken(token) {
    this.token = token;
    localStorage.setItem('admin_token', token);
  }

  clearToken() {
    this.token = null;
    localStorage.removeItem('admin_token');
  }

  getHeaders() {
    return {
      'Authorization': `Bearer ${this.token}`,
      'Content-Type': 'application/json'
    };
  }

  // Auth
  async login(username, password) {
    const response = await axios.post(`${API_URL}/api/admin/login`, {
      username,
      password
    });
    this.setToken(response.data.access_token);
    return response.data;
  }

  async setupAdmin(username, password) {
    const response = await axios.post(`${API_URL}/api/admin/setup`, {
      username,
      password
    });
    return response.data;
  }

  // Projects
  async getProjects() {
    const response = await axios.get(`${API_URL}/api/admin/projects`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async createProject(projectData) {
    const response = await axios.post(`${API_URL}/api/admin/projects`, projectData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async updateProject(projectId, projectData) {
    const response = await axios.put(`${API_URL}/api/admin/projects/${projectId}`, projectData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async deleteProject(projectId) {
    const response = await axios.delete(`${API_URL}/api/admin/projects/${projectId}`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async reorderProjects(projectIds) {
    const response = await axios.post(`${API_URL}/api/admin/projects/reorder`, projectIds, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Settings
  async getSettings() {
    const response = await axios.get(`${API_URL}/api/admin/settings`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async updateSettings(settingsData) {
    const response = await axios.put(`${API_URL}/api/admin/settings`, settingsData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Services
  async getServices() {
    const response = await axios.get(`${API_URL}/api/admin/services`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async createService(serviceData) {
    const response = await axios.post(`${API_URL}/api/admin/services`, serviceData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async updateService(serviceId, serviceData) {
    const response = await axios.put(`${API_URL}/api/admin/services/${serviceId}`, serviceData, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  async deleteService(serviceId) {
    const response = await axios.delete(`${API_URL}/api/admin/services/${serviceId}`, {
      headers: this.getHeaders()
    });
    return response.data;
  }

  // Upload
  async uploadImage(file) {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await axios.post(`${API_URL}/api/admin/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${this.token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  }
}

export default new AdminAPI();